// FILE: src/services/firestoreService.js (DIPERBAIKI)

import { db } from './firebase';
import { collection, getDocs, getDoc, addDoc, setDoc, updateDoc, deleteDoc, doc, writeBatch } from 'firebase/firestore';

// Universal in-memory cache
const _universalCache = {};

function getCacheKey(type, ...args) {
  return [type, ...args].join(':');
}

// --- NAMA FUNGSI INI DIPERBAIKI ---
// Sebelumnya: getCollectionAsArray, Sekarang: getCollection
export const getCollection = async (collectionPath) => {
  const cacheKey = getCacheKey('collection', collectionPath);
  if (_universalCache[cacheKey]) {
    return _universalCache[cacheKey];
  }
  const querySnapshot = await getDocs(collection(db, collectionPath));
  const dataArray = [];
  querySnapshot.forEach((doc) => {
    dataArray.push({ id: doc.id, ...doc.data() });
  });
  _universalCache[cacheKey] = dataArray;
  return dataArray;
};

// Menulis/menimpa banyak dokumen sekaligus dengan ID yang sudah ada (untuk fitur Restore)
export const batchSetDocuments = async (collectionPath, documents) => {
    const batch = writeBatch(db);
    documents.forEach((documentData) => {
        if (documentData.id) {
            const docRef = doc(db, collectionPath, documentData.id);
            const { id, ...data } = documentData;
            batch.set(docRef, data);
        }
    });
    await batch.commit();
};

// Menambah dokumen baru dengan ID otomatis dari Firebase
export const addDocument = async (path, data) => {
    return await addDoc(collection(db, path), data);
};

// Membuat/memperbarui dokumen dengan ID yang kita tentukan
export const setDocument = async (path, docId, data, merge = false) => {
    const docRef = doc(db, path, docId);
    return await setDoc(docRef, data, { merge });
};

// Memperbarui field tertentu dalam sebuah dokumen
export const updateDocument = async (path, docId, data) => {
    const docRef = doc(db, path, docId);
    return await updateDoc(docRef, data);
};

// Menghapus dokumen
export const deleteDocument = async (path, docId) => {
    const docRef = doc(db, path, docId);
    return await deleteDoc(docRef);
};

// Mengambil satu dokumen spesifik
export const getDocument = async (path, docId) => {
  const cacheKey = getCacheKey('doc', path, docId);
  if (_universalCache[cacheKey]) {
    return _universalCache[cacheKey];
  }
  const docRef = doc(db, path, docId);
  const docSnap = await getDoc(docRef);
  const result = docSnap.exists() ? { id: docSnap.id, ...docSnap.data() } : null;
  _universalCache[cacheKey] = result;
  return result;
};

// Fungsi ini digunakan oleh SiswaPage untuk impor CSV
export const batchAddDocuments = async (path, documents) => {
  const batch = writeBatch(db);
  documents.forEach((docData) => {
    const newDocRef = doc(collection(db, path));
    batch.set(newDocRef, docData);
  });
  await batch.commit();
};

// --- FUNGSI BARU DITAMBAHKAN DI SINI ---
// Fungsi baru untuk mengambil data paket langganan
export const getPackagesData = async () => {
  return await getDocument('settings', 'paket');
};